import React from 'react';
import {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import AlertModal from '../AlertModal'
import KeywordInfoCard from '../dashboard/trending-content/KeywordInfoCard'
import NewsItemCard from '../dashboard/trending-content/NewsItemCard'
import TopCategoriesCard from '../dashboard/trending-content/TopCategoriesCard'
import MissingIcon from '../../images/missing.jpg';
import PieCard from '../dashboard/trending-content/PieCard'
import CTATrendCard from './CTATrendCard'
import AssociatedNotifItem from '../dashboard/trending-content/AssociatedNotifItem'
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import IntegrationAnalysisCard2 from "../integrations/IntegrationAnalysisCard2";
import CTACampaignsCard from "./CTACampaignsCard";
import DashboardHeatmapCard from "../dashboard/DashboardHeatmapCard";
import CTAHeatmapCard from "./CTAHeatmapCard";


function CallToActionDetail({updateContentState, setAlertModalState, authToken, cta,  setModalState}) {

  const cta_emojis = {
    'purchase': '💸',
    'awareness': '👀',
    'download': '💾',
    'play': '🎮',
    'feedback': '✍️',
    'claim': '🏆',
    'reminder__advice__tip': '💡',
    'social': '🤳',
    'watch': '📺',
    'discover': '📰',
    'account_management': '⚙️',
  }
  const storage = getStorage();
  const [entityKeywords, setEntityKeywords] = useState({});
  const [selectedKeyword, setSelectedKeyword] = useState('');
  const [keywordInfoData, setKeywordInfoData] = useState([]);
  const [associatedNotifs, setAssociatedNotifs] = useState([]);
  const [newsItemCards, setNewsItemCards] = useState([]);
  const [trendData, setTrendData] = useState({});
  const [topMarkets, setTopMarkets] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [heatmapData, setHeatmapData] = useState([]);

  const [emotions, setEmotions] = useState([]);
  const [tones, setTones] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [timeExpressions, setTimeExpressions] = useState([]);
  const [dates, setDates] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [abuses, setAbuses] = useState({});
  const [sarcasm, setSarcasm] = useState({});

  useEffect(() => {
    fetchTrendFreq()
    fetchTopMarkets()
    fetchCampaigns()
    fetchEmotions()
    fetchTones()
    fetchHeatmap()
    /*fetchEntityKeywordData()
    fetchQuestions()
    fetchTimeExpressions()
    fetchDates()
    fetchTasks()
    fetchAbuses()
    fetchSarcasm()*/
  }, [authToken, setModalState]);

  async function fetchHeatmap() {
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-heatmap',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };

    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('heatmap' in response){
            setHeatmapData(response['heatmap'])
          }
          else{
            console.log('Heatmap data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchTrendFreq(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-freq',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('freq' in response){
            setTrendData(response['freq'])
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });

  }

  async function fetchTopMarkets(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-top-market',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {

          if('top' in response){
            setTopMarkets(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchCampaigns(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-campaigns',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {

          if('campaigns' in response){
            setCampaigns(response['campaigns'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  function timeSince(timestamp) {
    var milliseconds = parseInt(timestamp)
    const dateObject = new Date(milliseconds)
    var seconds = Math.floor((new Date() - dateObject) / 1000);
    if(seconds<0)
      seconds = 0

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " mins ago";
    }
    return Math.floor(seconds) + " secs ago";
  }

  function cleanTitle(n){
    if(n.title!='' && n.title!=undefined && n.title!='unknown')
      return n.title
    if(n.extraTitle!='' && n.extraTitle!=undefined && n.extraTitle!='unknown')
      return n.extraTitle
    return 'New message from '+n.appName
  }

  function filterAssociatedNotifs(filter, val){

    setTrendData({})
    setAssociatedNotifs([])
    setKeywordInfoData([])
    setNewsItemCards([])

    fetchTrendFreq(filter, val)

    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-associated-notifs',
        filt: filter,
        val: val
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {

          if('notifications' in response){
            var notifications = []
            for(var n of response['notifications']){
              n['extraText'] = ''
              n['appName'] = n.appname
              try {
                n['icon'] = await getDownloadURL(storageRef(storage, n.app + '.jpg'))
              } catch (e){
                n['icon'] = MissingIcon
              }
              n['title'] = cleanTitle(n)
              n['date'] = timeSince(n.id)

              notifications.push(n)
              notifications.sort(function (a, b) {
                return b.id > a.id ? 1 : -1
              })
            }
            setAssociatedNotifs(notifications.map((item) => {
              return (
                <AssociatedNotifItem
                  key={item.id}
                  id={item.id}
                  image={item.icon}
                  app={item.appName}
                  link={item.id}
                  title={item.title}
                  text={item.extraText}
                  date={item.date}
                  type={item.appName}
                  fav={item.id}
                />
              );
            }))
        }
        else{
          console.log('Associated notifications not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });

  }

  function prepKeywordForQuery(keyword){
    return keyword.replace(/\s+/g, "+")
  }

  function lastWeekDate(){
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7).toISOString().split('.')[0];
  }

  async function fetchRecentNews(keyword){
    fetch("https://api.thenewsapi.com/v1/news/top?language=en&api_token="+ process.env.REACT_APP_THE_NEWS_API_TOKEN +
      "&search="+prepKeywordForQuery(keyword)+"&limit=5&published_after="+lastWeekDate())
      .then(res => res.json())
      .then(
        (result) => {
          try{
            if('data' in result)
              setNewsItemCards(result.data.map((item, index) => {
                return (
                  <NewsItemCard
                    id={item.uuid}
                    title={item.title}
                    textContent={item.description}
                    imageURL={item.image_url}
                    published={item.published_at}
                    link={item.url}
                  />
                );
              }))
          } catch (e) {
            console.log('Error getting news: ')
            console.log(e)
            setNewsItemCards([])
          }
        },
        (error) => {
          console.log(error)
          setNewsItemCards([])
        }
      )
  }

  async function fetchKeywordInfo(keyword){
    filterAssociatedNotifs('keywords', keyword)
    fetch("https://api.duckduckgo.com/?q="+prepKeywordForQuery(keyword)+"&skip_disambig=1&format=json&pretty=1&t=empushy")
      .then(res => res.json())
      .then(
        (result) => {
          try{
            var keywordInfoList = []
            if(result['Abstract'] !=''){
              var keywordInfo = {}
              keywordInfo['heading'] = result['Heading']
              keywordInfo['abstract'] = result['Abstract']
              keywordInfo['image'] = result['Image']
              keywordInfo['url'] = result['AbstractURL']
              keywordInfoList.push(keywordInfo)
            }
            if (result.hasOwnProperty('RelatedTopics')){
              for(var i=0; i<3 && i<result['RelatedTopics'].length; i++){
                if(!result['RelatedTopics'][i].hasOwnProperty('name')) {
                  var keywordInfo = {}
                  try{
                    if(result['Heading']=='')
                      keywordInfo['heading'] = result['RelatedTopics'][i]['FirstURL'].split('.com/')[1].replace('_', ' ')
                    else
                      keywordInfo['heading'] = result['Heading']
                  }
                  catch (e) {
                    keywordInfo['heading'] = keyword
                  }
                  keywordInfo['abstract'] = result['RelatedTopics'][i]['Text']
                  if(result['RelatedTopics'][i].hasOwnProperty('Icon'))
                    keywordInfo['image'] = result['RelatedTopics'][i]['Icon']['URL']
                  else
                    keywordInfo['image'] = ''
                  keywordInfo['url'] = result['RelatedTopics'][i]['FirstURL']
                  keywordInfoList.push(keywordInfo)
                }
              }
            }
            setKeywordInfoData(keywordInfoList)
          } catch (e) {
            console.log('Error converting keyword results: ')
            console.log(e)
            setKeywordInfoData([])
          }
          fetchRecentNews(keyword)
        },
        (error) => {
          console.log(error)
          setKeywordInfoData([])
        }
      )
  }

  async function fetchEntityKeywordData(){
    setEntityKeywords([])
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-entity-cloud'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('keywords' in response){
          setEntityKeywords(response['keywords'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchEmotions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-emotions',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setEmotions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTones(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-tones',
        val: cta.state
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('top' in response){
            setTones(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchQuestions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-questions'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setQuestions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTimeExpressions(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-time'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTimeExpressions(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchDates(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-dates'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setDates(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTasks(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-tasks'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTasks(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchAbuses(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-abuse'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('pie' in response){
          setAbuses(response['pie'])
        }
        else{
          console.log('Pie data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchSarcasm(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'trending-content-sarcasm'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('pie' in response){
          setSarcasm(response['pie'])
        }
        else{
          console.log('Pie data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  return (

    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">

      <Helmet>
        <title>EmPushy | Call-to-actions</title>
      </Helmet>

      {/* Page content */}
      <div className="flex w-full">
        {/* Content */}
        <div className="w-full">
          <div className="mb-6">
            <ul className="inline-flex flex-wrap text-sm font-medium">
              <li className="flex items-center">
                <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                     onClick={()=>updateContentState(null)}>Call-to-actions</div>
                <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                  <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                </svg>
              </li>
              <li className="flex items-center">
                <a className="text-slate-500">{cta.title}</a>
              </li>
            </ul>
          </div>
          <header className="mb-4">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">{cta_emojis[cta.state]} {cta.title}</h1>
            <p className="mb-6 text-justify">{cta.textContent}</p>
          </header>

          {/* Image */}
          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <CTATrendCard data={trendData}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Market Frequency" category="Market Vertical" data={topMarkets} palette={2}
                                 hint={"These market verticals use the " + cta.title + " CTA most frequently."}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <CTAHeatmapCard data={heatmapData} title={'Popular Delivery Times for "'+cta.title+'" Campaigns'}
                            hint={'Scheduled delivery of messages to audience subscribers.'}/>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <CTACampaignsCard data={campaigns} cta={cta.title} setModalState={setModalState}/>
          </div>


          {/*<div className="flex flex-row mb-5 gap-6">
            <TopCategoriesCard title="Trending Topics" category="Topic" data={emotions} palette={2}
                               hint="Trending topics found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"/>
            <TopCategoriesCard title="Trending Call-to-actions" category="CTA" data={emotions} palette={3}
                               hint="Trending Call-to-actions found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"/>
          </div>*/}

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title={'Trending Emotion in "'+cta.title+'" campaigns'} category="Emotion" data={emotions} palette={0}
                                 hint="Trending use of emotion found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title={'Trending Tone in "'+cta.title+'" campaigns'} category="Tone" data={tones} palette={1}
                               hint="Trending use of tone found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                               filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>


          {/*<div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <PieCard title="Abuse Detection" category="Abuse" data={abuses}
                                 hint="Abusive language detected in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <PieCard title="Sarcasm Detection" category="Sarcasm" data={sarcasm}
                       hint="Sarcastic language detected in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                       palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title="Trending Questions" category="Question" data={questions}
                               hint="Trending question types found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={2} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Time Expressions" category="Time" data={timeExpressions}
                               hint="Trending time expressions found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                               palette={3} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>

          <div className="flex flex-wrap mb-5 gap-6">
            <div className="flex-1">
              <TopCategoriesCard title="Trending Dates" category="Date" data={dates}
                                 hint="Trending date types found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={0} filterFunc={filterAssociatedNotifs}/>
            </div>
            <div className="flex-1">
              <TopCategoriesCard title="Trending Tasks" category="Task" data={tasks}
                                 hint="Trending tasks found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                                 palette={1} filterFunc={filterAssociatedNotifs}/>
            </div>
          </div>*/}


          {/* Post content */}
          {/*<div>
                      <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Meetup Details</h2>
                      <p className="mb-6">In the world of AI, behavioural predictions are leading the charge to better machine learning.</p>
                      <p className="mb-6">
                        There is so much happening in the AI space. Advances in the economic sectors have seen automated business practices rapidly
                        increasing economic value. While the realm of the human sciences has used the power afforded by computational capabilities to
                        solve many human based dilemmas. Even the art scene has adopted carefully selected ML applications to usher in the technological
                        movement.
                      </p>
                      <p className="mb-6">
                        Join us every second Wednesday as we host an open discussion about the amazing things happening in the world of AI and machine
                        learning. Feel free to share your experiences, ask questions, ponder the possibilities, or just listen as we explore new topics
                        and revisit old ones.
                      </p>
                    </div>
                    <hr className="my-6 border-t border-slate-200" />*/}

        </div>
      </div>
    </div>
  );
}

export default CallToActionDetail;